import { render, staticRenderFns } from "./WalletOverview.vue?vue&type=template&id=362fb992&scoped=true"
import script from "./WalletOverview.vue?vue&type=script&lang=js"
export * from "./WalletOverview.vue?vue&type=script&lang=js"
import style0 from "./WalletOverview.vue?vue&type=style&index=0&id=362fb992&prod&lang=scss&scoped=true"
import style1 from "./WalletOverview.vue?vue&type=style&index=1&id=362fb992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362fb992",
  null
  
)

export default component.exports